import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import * as serviceWorker from './serviceWorker';
import theme from './components/theme';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider } from './contexts/ThemeContext';
import { BrandingProvider } from './contexts/BrandingContext';
import ErrorBoundary from './components/ErrorBoundary';

// Globale Styles in fester Reihenfolge (vermeidet mini-css-extract CI-Fehler)
import './css/main.css';
import './css/sidebar.css';
import './css/topbar.css';
import './css/titlebar.css';
import './css/card.css';
import './css/settings.css';

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <BrandingProvider>
          <MuiThemeProvider theme={theme}>
            <Router>
              <App />
            </Router>
          </MuiThemeProvider>
        </BrandingProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
